module.exports = __webpack_public_path__ + "media/images/landing-pages/encryption_and_cryptography_course-276e777523dcfea15e3832a552d778d1.png";